// packages/chatbot/src/utils/jwt.ts
export function decodeJwtPayload<T = any>(jwt: string): T | null {
    if (!jwt || typeof jwt !== 'string') return null;
    try {
      const parts = jwt.split('.');
      if (parts.length < 2) return null;
      const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      const json = decodeURIComponent(
        atob(payload)
          .split('')
          .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(json) as T;
    } catch {
      return null;
    }
  }
  